module.exports = __webpack_public_path__ + "img/motorcycle-dark-grey.7841f5a4.svg";